/**
 * Pure entity resolvers for notification display context (no feature imports).
 */

/**
 * @typedef {Object} LoginOrganizationEntry
 * @property {string|number} [organization_id]
 * @property {string|number} [id]
 * @property {string} [organization_name]
 * @property {string} [name]
 * @property {string} [naziv]
 */

/**
 * @typedef {Object} LoginOrganizations
 * @property {LoginOrganizationEntry[]} [verified]
 * @property {LoginOrganizationEntry[]} [requested]
 */

/**
 * @typedef {Object} ResolvedOrganization
 * @property {string|number} id
 * @property {string} name
 */

/**
 * @typedef {Object} ObligationInPreparation
 * @property {string|number} id
 * @property {string} [name]
 * @property {string} [status]
 * @property {Record<string, unknown>} [key]
 */

/**
 * Vraća organizaciju iz liste (verified + requested) po related_entity_id.
 * @param {LoginOrganizations|null|undefined} loginOrganizations
 * @param {string|number|null|undefined} relatedEntityId
 * @returns {ResolvedOrganization|null}
 */
export function getOrganizationByEntityId(loginOrganizations, relatedEntityId) {
  if (!relatedEntityId || !loginOrganizations) return null;
  const idStr = String(relatedEntityId);
  const verified = loginOrganizations.verified || [];
  const requested = loginOrganizations.requested || [];
  const found = verified.find((org) => {
    const oid = org.organization_id ?? org.id ?? org;
    return String(oid) === idStr;
  }) || requested.find((org) => {
    const oid = org.organization_id ?? org.id ?? org;
    return String(oid) === idStr;
  });
  if (!found) return null;
  return {
    id: found.organization_id ?? found.id,
    name: found.organization_name ?? found.name ?? found.naziv ?? 'Организација',
  };
}

/**
 * Vraća obavezu iz liste obaveza u pripremi (DRAFT AP, UNDER_REVIEW) po id.
 * @param {ObligationInPreparation[]|null|undefined} obligationsInPreparation
 * @param {string|number|null|undefined} obligationId
 * @returns {ObligationInPreparation|null}
 */
export function getObligationInPreparationById(obligationsInPreparation, obligationId) {
  if (!obligationId || !Array.isArray(obligationsInPreparation)) return null;
  const idStr = String(obligationId);
  return obligationsInPreparation.find((o) => String(o?.id) === idStr) || null;
}
